import { render, staticRenderFns } from "./page-manager.vue?vue&type=template&id=323ba4d7&scoped=true&"
import script from "./page-manager.vue?vue&type=script&lang=js&"
export * from "./page-manager.vue?vue&type=script&lang=js&"
import style0 from "./page-manager.vue?vue&type=style&index=0&id=323ba4d7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323ba4d7",
  null
  
)

export default component.exports